import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import Yup from '../../../../vendor/yup';



export const mkValidationSchema = Yup.lazy((values) => {
  return (
    Yup.object().shape({
      id: Yup.string().min(1),
      title: Yup.string(),
      status: Yup.string(),
      content_type: Yup.string(),
      created_from: Yup.string().test(
        'test_date_after',
        'Created from date must be same or before than created to',
        (value) => {
          if (!isEmpty(values?.created_to) && !isEmpty(value)) {
            return moment(values?.created_to).isSameOrAfter(value);
          }
          return true;
        },
      ),
      created_to: Yup.string().test(
        'test_date_before',
        'Created from date must be same or after than created to',
        (value) => {
          if (!isEmpty(values?.created_from) && !isEmpty(value)) {
            return moment(values?.created_from).isSameOrBefore(value);
          }
          return true;
        },
      ),
    }));
});
